import type { SearchHistory } from '../../../common/schema/schemaType'

export const searchHistoryMem: SearchHistory[] = []
